module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d598af31b0e198e03cd.worker.js");
};